import { extractApiErrorMessage } from "@velizhanin-dev/api-errors"
import { SearchX } from "lucide-react"
import type { ReactNode } from "react"
import { PostCardSkeleton } from "@/entities/post"
import type { Post } from "@/shared/lib/types"
import { Crossfade } from "@/shared/ui/crossfade"
import { EmptyState } from "@/shared/ui/empty-state"
import { LoadErrorState } from "@/shared/ui/load-error-state"
import { PostGrid } from "./post-grid"

interface PostsFeedProps {
	posts: Post[]
	isLoading: boolean
	isError?: boolean
	error?: unknown
	onRetry?: () => void
	isFetchingNextPage: boolean
	hasNextPage: boolean
	onLoadMore: () => void
	emptyMessage: string
	errorMessage?: string
	emptyAction?: ReactNode
}

export function PostsFeed({
	posts,
	isLoading,
	isError,
	error,
	onRetry,
	isFetchingNextPage,
	hasNextPage,
	onLoadMore,
	emptyMessage,
	errorMessage = "Не удалось загрузить публикации. Попробуйте ещё раз.",
	emptyAction,
}: PostsFeedProps) {
	const state = isLoading
		? "loading"
		: isError && posts.length === 0
			? "error"
			: posts.length === 0
				? "empty"
				: "content"

	return (
		<Crossfade state={state}>
			{state === "loading" && (
				<div className="grid grid-cols-1 gap-4 lg:gap-6">
					{Array.from({ length: 6 }).map((_, i) => (
						<PostCardSkeleton key={i} />
					))}
				</div>
			)}

			{state === "error" && (
				<LoadErrorState message={extractApiErrorMessage(error, errorMessage)} onRetry={onRetry} />
			)}

			{state === "empty" && <EmptyState icon={SearchX} title={emptyMessage} action={emptyAction} />}

			{state === "content" && (
				<>
					<PostGrid
						posts={posts}
						hasNextPage={hasNextPage && !isError}
						isFetchingNextPage={isFetchingNextPage}
						onLoadMore={onLoadMore}
					/>
					{isError && (
						<LoadErrorState
							message="Не удалось загрузить следующую страницу"
							onRetry={onLoadMore}
						/>
					)}
				</>
			)}
		</Crossfade>
	)
}
